import { useCanOpenStep, useExperience } from '@cascade/react/experiences';
import { Button } from '@cascade/ui-library';
import type { TSideStepButtonProps } from './SideStepButton.types.ts';

export const SideStepButton = ({ button }: TSideStepButtonProps) => {
  const { openStep } = useExperience();
  const canOpenStep = useCanOpenStep();

  const openSideStep = () => openStep(button.step_id);

  return (
    <Button
      variant='secondary'
      size='sm'
      iconType='sparkle'
      label={button.button_label}
      disabled={!canOpenStep}
      onClick={openSideStep}
    />
  );
};
